 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"index": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "static/js/" + ({"components-uni-fixed-uni-fixed-uni-fixed":"components-uni-fixed-uni-fixed-uni-fixed","pages-accountSettings-accountSettings~pages-assets-account-bill~pages-assets-address-list~pages-asse~f7f03e8c":"pages-accountSettings-accountSettings~pages-assets-account-bill~pages-assets-address-list~pages-asse~f7f03e8c","pages-accountSettings-accountSettings~pages-assets-account-bill~pages-assets-address-list~pages-asse~59f65f44":"pages-accountSettings-accountSettings~pages-assets-account-bill~pages-assets-address-list~pages-asse~59f65f44","pages-accountSettings-accountSettings~pages-assets-account-bill~pages-assets-address-list~pages-asse~88ccec46":"pages-accountSettings-accountSettings~pages-assets-account-bill~pages-assets-address-list~pages-asse~88ccec46","pages-accountSettings-accountSettings~pages-assets-account-bill~pages-assets-address-list~pages-asse~11e4e255":"pages-accountSettings-accountSettings~pages-assets-account-bill~pages-assets-address-list~pages-asse~11e4e255","pages-accountSettings-accountSettings":"pages-accountSettings-accountSettings","pages-assets-account-bill":"pages-assets-account-bill","pages-assets-address-list":"pages-assets-address-list","pages-assets-currency-bill":"pages-assets-currency-bill","pages-assets-draw":"pages-assets-draw","pages-assets-edit-address":"pages-assets-edit-address","pages-assets-miner-bill":"pages-assets-miner-bill","pages-auth-primary":"pages-auth-primary","pages-base-destroy-coin":"pages-base-destroy-coin","pages-base-index":"pages-base-index","pages-commission-index":"pages-commission-index","pages-commission-revoke":"pages-commission-revoke","pages-currency-index":"pages-currency-index","pages-exchange-contractHis":"pages-exchange-contractHis","pages-exchange-exchangeHis":"pages-exchange-exchangeHis","pages-exchange-his":"pages-exchange-his","pages-exchange-index":"pages-exchange-index","pages-income-index":"pages-income-index","pages-index-index":"pages-index-index","pages-invite-index":"pages-invite-index","pages-login-index":"pages-login-index","pages-miner-data":"pages-miner-data","pages-miner-miner":"pages-miner-miner","pages-miner-power":"pages-miner-power","pages-miner-produce":"pages-miner-produce","pages-miner-team":"pages-miner-team","pages-notice-detail":"pages-notice-detail","pages-notice-index":"pages-notice-index","pages-notice-msg-detail":"pages-notice-msg-detail","pages-option-index":"pages-option-index","pages-otc-ad":"pages-otc-ad","pages-otc-bill":"pages-otc-bill","pages-otc-bind-pay":"pages-otc-bind-pay","pages-otc-detail":"pages-otc-detail","pages-otc-order":"pages-otc-order","pages-otc-pays":"pages-otc-pays","pages-otc-send-ad":"pages-otc-send-ad","pages-purchase-index":"pages-purchase-index","pages-reg-email":"pages-reg-email","pages-reg-index":"pages-reg-index","pages-safe-email":"pages-safe-email","pages-safe-forget-password":"pages-safe-forget-password","pages-safe-google":"pages-safe-google","pages-safe-index":"pages-safe-index","pages-safe-login-password":"pages-safe-login-password","pages-safe-phone":"pages-safe-phone","pages-safe-transaction-password":"pages-safe-transaction-password","pages-service-index":"pages-service-index","pages-service-otc":"pages-service-otc","pages-service-service":"pages-service-service","pages-transfer-index":"pages-transfer-index","pages-assets-paypal~pages-auth-senior~pages-transfer-bill":"pages-assets-paypal~pages-auth-senior~pages-transfer-bill","pages-transfer-bill":"pages-transfer-bill","pages-assets-paypal~pages-assets-recharge":"pages-assets-paypal~pages-assets-recharge","pages-assets-paypal":"pages-assets-paypal","pages-auth-senior":"pages-auth-senior","pages-upgrade-index":"pages-upgrade-index","pages-assets-bill~pages-currency-list":"pages-assets-bill~pages-currency-list","pages-assets-bill":"pages-assets-bill","pages-currency-list":"pages-currency-list","pages-assets-recharge~pages-list-list":"pages-assets-recharge~pages-list-list","pages-assets-recharge":"pages-assets-recharge","pages-list-list":"pages-list-list","pages-auth-index":"pages-auth-index","pages-base-miner":"pages-base-miner","pages-help-detail":"pages-help-detail","pages-help-index":"pages-help-index","pages-help-sort":"pages-help-sort","pages-invite-level":"pages-invite-level","pages-option-delivery-detail":"pages-option-delivery-detail","pages-purchase-bill":"pages-purchase-bill","pages-startPage-index":"pages-startPage-index"}[chunkId]||chunkId) + "." + {"components-uni-fixed-uni-fixed-uni-fixed":"4b5e9b08","pages-accountSettings-accountSettings~pages-assets-account-bill~pages-assets-address-list~pages-asse~f7f03e8c":"e1c9d312","pages-accountSettings-accountSettings~pages-assets-account-bill~pages-assets-address-list~pages-asse~59f65f44":"a9de0293","pages-accountSettings-accountSettings~pages-assets-account-bill~pages-assets-address-list~pages-asse~88ccec46":"a39a8d20","pages-accountSettings-accountSettings~pages-assets-account-bill~pages-assets-address-list~pages-asse~11e4e255":"84335db6","pages-accountSettings-accountSettings":"34637bac","pages-assets-account-bill":"cef86d37","pages-assets-address-list":"755ffe4c","pages-assets-currency-bill":"8a34102a","pages-assets-draw":"b1df8df4","pages-assets-edit-address":"a080bdf7","pages-assets-miner-bill":"5e3c9f57","pages-auth-primary":"bac54e90","pages-base-destroy-coin":"6438432b","pages-base-index":"811f0eae","pages-commission-index":"912c6af8","pages-commission-revoke":"362449eb","pages-currency-index":"a9b4fa9a","pages-exchange-contractHis":"335729af","pages-exchange-exchangeHis":"e61e2b5d","pages-exchange-his":"62a78404","pages-exchange-index":"db5704e0","pages-income-index":"eaf2f387","pages-index-index":"8821b7ab","pages-invite-index":"90935a14","pages-login-index":"b3c79f8c","pages-miner-data":"2451176b","pages-miner-miner":"3ac38419","pages-miner-power":"98dddd08","pages-miner-produce":"04cd54c2","pages-miner-team":"7c618286","pages-notice-detail":"0ee15ad5","pages-notice-index":"bc023556","pages-notice-msg-detail":"e9e737e4","pages-option-index":"dff585e5","pages-otc-ad":"295616d6","pages-otc-bill":"f678fa3a","pages-otc-bind-pay":"658dcebc","pages-otc-detail":"7ab24e07","pages-otc-order":"cb0e544e","pages-otc-pays":"a1baf298","pages-otc-send-ad":"aeb62ac7","pages-purchase-index":"540df448","pages-reg-email":"2bf495e9","pages-reg-index":"cfeac9c4","pages-safe-email":"79042ba8","pages-safe-forget-password":"3d0261ac","pages-safe-google":"ea9d1d8b","pages-safe-index":"52bc4a5e","pages-safe-login-password":"90eb5ad3","pages-safe-phone":"381aae98","pages-safe-transaction-password":"b2899c16","pages-service-index":"b814a87e","pages-service-otc":"b118dcef","pages-service-service":"cf44d10c","pages-transfer-index":"4e2674d3","pages-assets-paypal~pages-auth-senior~pages-transfer-bill":"9f264b18","pages-transfer-bill":"6f108793","pages-assets-paypal~pages-assets-recharge":"6af310c6","pages-assets-paypal":"2c343cf7","pages-auth-senior":"fa3a7444","pages-upgrade-index":"30329261","pages-assets-bill~pages-currency-list":"7a9b59e6","pages-assets-bill":"9d326424","pages-currency-list":"1a9b3b21","pages-assets-recharge~pages-list-list":"49c90b66","pages-assets-recharge":"3738566c","pages-list-list":"a95a3a87","pages-auth-index":"b536c27a","pages-base-miner":"e12a851e","pages-help-detail":"d7b5be51","pages-help-index":"b54a8cc2","pages-help-sort":"92a3f8c5","pages-invite-level":"c98a8aa3","pages-option-delivery-detail":"32c97b67","pages-purchase-bill":"674c2fff","pages-startPage-index":"c42e050e"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "./";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
